<template>
	<div>
        <b-row>
          <b-col>
            <h2>HALO</h2>
          </b-col>
        </b-row>
        <hr />
        <transition-group name="t" tag="div">
          <b-row v-for="field in this.fields" :key="` ${field.name}`" :class="!selectedFields.includes(field) ? 'no-show' : 'mt--3'">
            <HaloInput :field="field" :scenarioName="scenarioName"/>
          </b-row>
        </transition-group>
    </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import HaloInput from "../HaloInputs/HaloInput";
import { mapGetters } from "vuex";

export default {
  components: {
    HaloInput,
  },

  props: {
    fields: Array,
    scenarioName: String
  },

  setup() {
    return { v$: useVuelidate() };
  },

  computed: {
    ...mapGetters(["getSelectedProgram", "getSelectedSection", "getScenario"]),
    selectedFields() {
      return this.getScenario.fields.filter(f => (f.sections.includes(this.getSelectedSection.name) && f.programs.includes(this.getSelectedProgram(this.scenarioName))) || f.name === 'Program');
    },
  },
};
</script>

<style scoped>
hr {
  margin-top: 1rem;
}
</style>

<style>
.no-show {
  width: 0;
  height: 0;
  position: absolute;
  visibility: hidden;
}
</style>

<style scoped lang="scss">
.t {
  
  &-move {
    transition: all .2s linear; transform: .3s translateX(-1em);
  }
  
  &-leave-active {
    transition: opacity .2s linear, transform .2s; //cubic-bezier(.7,0,.7,1); 
  }
  
  &-enter-active { 
    transition: opacity .2s linear, transform .2s;
    transition-delay: 0.2s;
  }

  &-enter, 
  &-leave-to {
    opacity: 0;
  }
  
  &-enter { transform: translateX(-1rem); }
  &-leave-to { transform: translateX(1em); }

}
</style>